import Swiper from 'swiper/bundle';

if($(".resultate-slider.swiper-container").length > 0) {
    const resultate_swiper = new Swiper(".resultate-slider.swiper-container", {
        slidesPerView: 'auto',
        loop: false,
        navigation: {
            nextEl: ".swiper-button-next.resultate-swiper-button",
            prevEl: ".swiper-button-prev.resultate-swiper-button",
        },
    });
}